import 'angular-ui-router';
import 'angular-ui-bootstrap';
import 'angular-breadcrumb';

/* Module Imports */
import jobSchedulesJobModule from './job/job.module';

/* Additional Imports */
import JobsController from './jobs.controller';

/* Filters */
import PrintScheduleDateRange from './job/filters/printScheduleDateRange.filter';

const jobSchedulesModule = angular
	.module('app.jobschedules', [
		//INTERNAL
		jobSchedulesJobModule,

		//THIRD PARTY
		'ui.router',
		'ui.bootstrap',
		'ncy-angular-breadcrumb'
	])
	.controller('JobsController', JobsController)
	.filter('printScheduleDateRange', PrintScheduleDateRange);

export default jobSchedulesModule.name;
